// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5rQTJ","rootMobile":"styles_rootMobile__1K0gu"};